<template>
    <div>
        <multiselect
            :placeholder="$t('select')"
            v-model="selected"
            :options="options"
            :class="validateError != '' ? 'box-border-color':''"
            @input="handleInput"
            label="text"
            track-by="value"
            :multiple="false"
            :select-label="''"
            :selected-label="''"
            :deselect-label="''"
            :allow-empty="false"
            :searchable="true">
            <span slot="noOptions">
                {{ $t('no_options') }}
            </span>
            <span slot="noResult">
                {{ $t('no_result') }}
            </span>
        </multiselect>
        <span class="invalid-feedback-custom"
              v-show="validateError"
              v-html="validateError">
        </span>
    </div>
</template>

<script>
import setSelected from "@/helpers/setSelected";
import qs from "qs";
import ParameterService from "@/services/ParameterService";

export default {
    props: {
        value: {
            default: null
        },
        validateError: {
            type: String,
            default: ''
        },
        showEur: {
            default: true
        },
        code: {
            type: String,
            default: 'currencies'
        },
        showAllTL: {
            type: Boolean,
            default: false
        },
        tlLabel: {
            type: String,
            default: null
        },
        setOptions: {
            type: Boolean,
            default: true
        },
    },
    watch: {
        value: function (newValue) {
            if (this.options.length > 0) {
                this.selected = this.options.filter(c => c.value == newValue);
            }
        },
        showAllTL() { this.getOptions(); },
    },
    data() {
        return {
            selected: this.value,
            options: [],
        }
    },
    methods: {
        setSelected: setSelected,
        getOptions() {
            this.options = [];

            if (this.setOptions) {
                this.options.push({ value: null, text: this.$t('select') });
            }

            const config = {
              params: {
                  sort: this.sort,
                  limit: -1
              },
              paramsSerializer: (params) => qs.stringify(params, {encode: false})
            }

            ParameterService.getItems(this.code, config)
              .then(response => {
                  const data = response.data.data;
                  if (data && data.items) {
                      data.items.forEach(item => {
                          if (!this.showEur && item.code === 'EUR') {
                              return;
                          }
                          this.options.push({
                              value: item.code,
                              text: this.$i18n.locale == 'tr' ? item.name : item.name_en,
                          });
                      });
                  }
              })
              .then(() => {
                  if (this.showAllTL) {
                      if (!this.options.some(o => o.value === 'TL')) {
                          this.options.push({ value: 'TL', text: this.tlLabel || 'HEPSİ TRY' });
                      }
                  } else {
                      this.options = this.options.filter(o => o.value !== 'TL');
                      if (this.value === 'TL') {
                          this.$emit('input', null);
                      }
                  }

                  this.selected = this.setSelected(this.value, this.options, this.multiple);
              })
        },
        handleInput(event) {
            if (event && event.value) {
                this.$emit('input', event.value);
            }
            else {
                this.$emit('input', null);
            }
        },
        getText(id){
            let found=null
            this.options.forEach((item)=>{
                if(item.value===id){
                    found = item.text;
                }
            });
            return found;
        },
        getItem(id){
            let found=null
            this.options.forEach((item)=>{
                if(item.value===id){
                    found = item;
                }
            });
            return found;
        }
    },
    created() {
        this.getOptions();
    }
};
</script>
